import { Routes } from "@angular/router";
import { SetupCompleteGuard } from "src/app-legacy/core/guards/setup-complete.guard";
import { SetupGuard } from "src/app-legacy/core/guards/setup.guard";
import { authGuard } from "./core/guards/auth.guard";
import { internalViewGuard } from "./core/guards/internal-view.guard";
import { regularViewGuard } from "./core/guards/regular-view.guard";
import { InternalViewLayoutComponent } from "./layout/internal-view-layout/internal-view-layout.component";
import { MainLayoutComponent } from "./layout/main-layout/main-layout.component";

export const routes: Routes = [
	{
		path: "auth",
		loadChildren: () => import("./features/auth/auth.routes").then((m) => m.routes),
		// canActivate: [noAuthGuard],
	},
	{
		path: "terms-and-conditions",
		loadChildren: () =>
			import("../app-legacy/main/terms-and-conditions/terms-and-conditions.module").then(
				(m) => m.TermsAndConditionsModule,
			),
	},
	{
		path: "setup",
		canActivate: [authGuard, SetupCompleteGuard],
		loadChildren: () => import("../app-legacy/main/setup/setup.module").then((m) => m.SetupModule),
	},
	{
		path: "subscription",
		canActivate: [authGuard],
		loadChildren: () => import("../app-legacy/main/subscription/subscription.routes").then((m) => m.routes),
	},
	{
		path: "faqs",
		loadChildren: () => import("../app-legacy/main/faqs/faqs.module").then((m) => m.FaqsModule),
	},
	{
		path: "payroll-getting-started",
		loadChildren: () =>
			import("../app-legacy/main/payroll/getting-started/getting-started.module").then((m) => m.GettingStartedModule),
	},
	{
		path: "internal-views",
		canActivate: [authGuard, internalViewGuard],
		component: InternalViewLayoutComponent,
		loadChildren: () => import("./features/internal-views/internal-views.routes").then((m) => m.routes),
	},
	{
		path: "",
		component: MainLayoutComponent,
		canActivate: [authGuard, SetupGuard, regularViewGuard],
		children: [
			{
				path: "dashboard",
				loadChildren: () => import("../app-legacy/main/dashboard/dashboard.routes").then((m) => m.routes),
			},
			{
				path: "other-income",
				loadChildren: () =>
					import("../app-legacy/main/other-income/other-income.module").then((m) => m.OtherIncomeModule),
			},
			{
				path: "expense",
				loadChildren: () => import("../app-legacy/main/expense/expense.module").then((m) => m.ExpenseModule),
			},
			{
				path: "invoicing",
				loadChildren: () => import("../app-legacy/main/invoicing/invoicing.module").then((m) => m.InvoicingModule),
			},
			{
				path: "accounting",
				loadChildren: () => import("../app-legacy/main/accounting/accounting.module").then((m) => m.AccountingModule),
			},
			{
				path: "students",
				loadChildren: () => import("../app-legacy/main/students/students.module").then((m) => m.StudentsModule),
			},
			{
				path: "messaging",
				loadChildren: () => import("../app-legacy/main/messaging/messaging.module").then((m) => m.MessagingModule),
			},
			{
				path: "user",
				loadChildren: () => import("../app-legacy/main/user/user.module").then((m) => m.UserModule),
			},
			{
				path: "settings",
				loadChildren: () => import("../app-legacy/main/settings/settings.module").then((m) => m.SettingsModule),
			},
			{
				path: "student-profile",
				loadChildren: () =>
					import("../app-legacy/main/student-profile/student-profile.module").then((m) => m.StudentProfileModule),
			},
			{
				path: "admin",
				loadChildren: () => import("../app-legacy/main/admin/admin.module").then((m) => m.AdminModule),
			},
			{
				path: "configurations",
				loadChildren: () =>
					import("../app-legacy/main/configurations/configurations.module").then((m) => m.ConfigurationsModule),
			},
			{
				path: "collections",
				loadChildren: () =>
					import("../app-legacy/main/collections/collections.module").then((m) => m.CollectionsModule),
			},

			{
				path: "billing",
				loadChildren: () => import("./features/billing/billing.routes").then((m) => m.routes),
			},
			{
				path: "classes",
				loadChildren: () => import("./features/classes/classes.routes").then((m) => m.routes),
			},
			{
				path: "invoicing",
				loadChildren: () => import("../app-legacy/main/invoicing/invoicing.module").then((m) => m.InvoicingModule),
			},
			{
				path: "student-reports",
				loadChildren: () =>
					import("../app-legacy/main/students/student-reports/student-reports.module").then(
						(m) => m.StudentReportsModule,
					),
			},
			{
				path: "summary-reports",
				loadChildren: () =>
					import("../app-legacy/main/summary-reports/summary-reports.module").then((m) => m.SummaryReportsModule),
			},
			{
				path: "financial-reports",
				loadChildren: () =>
					import("../app-legacy/main/financial-reports/financial-reports.module").then((m) => m.FinancialReportsModule),
			},
			{
				path: "ipsas-reports",
				loadChildren: () =>
					import("../app-legacy/main/ipsas-reports/ipsas-reports.module").then((m) => m.IpsasReportsModule),
			},
			{
				path: "aging-reports",
				loadChildren: () =>
					import("../app-legacy/main/aging-reports/aging-reports.module").then((m) => m.AgingReportsModule),
			},
			{
				path: "pocket-money",
				loadChildren: () =>
					import("../app-legacy/main/pocket-money/pocket-money.module").then((m) => m.PocketMoneyModule),
			},
			{
				path: "transport",
				loadChildren: () => import("../app-legacy/main/transport/transport.routes").then((m) => m.routes),
			},
			{
				path: "asset-management",
				loadChildren: () =>
					import("../app-legacy/main/asset-management/asset-management.module").then((m) => m.AssetManagementModule),
			},
			{
				path: "billing",
				loadChildren: () => import("./features/billing/billing.routes").then((m) => m.routes),
			},
			{
				path: "payroll",
				loadChildren: () => import("../app-legacy/main/payroll/payroll.module").then((m) => m.PayrollModule),
			},
			{
				path: "deletion-logs",
				loadChildren: () =>
					import("../app-legacy/main/deletion-logs/deletion-logs.module").then((m) => m.DeletionLogsModule),
			},
			{
				path: "integrations",
				loadChildren: () =>
					import("../app-legacy/main/integrations/school-integrations/school-integrations.module").then(
						(m) => m.IntegrationsModule,
					),
			},
			{
				path: "staff",
				loadChildren: () =>
					import("../app-legacy/main/private-entity/staff-management/staff-management.routes").then((m) => m.routes),
			},
			{
				path: "staff-leaves",
				loadChildren: () =>
					import("../app-legacy/main/private-entity/staff-management/leaves/leaves.routes").then((m) => m.routes),
			},
			{
				path: "private-financial-reports",
				loadChildren: () =>
					import("../app-legacy/main/private-entity/reports/reports.module").then((m) => m.ReportsModule),
			},
			{
				path: "customer-support",
				loadChildren: () => import("../app-legacy/main/support/support.routes").then((m) => m.routes),
			},
			{
				path: "notifications",
				loadChildren: () =>
					import("../app-legacy/main/notifications/notifications.module").then((m) => m.NotificationsModule),
			},
			{
				path: "stores-inventory",
				loadChildren: () => import("../app-legacy/main/stores-inventory/stores-inventory.routes").then((m) => m.routes),
			},

			{
				path: "private",
				children: [
					{
						path: "company",
						loadChildren: () =>
							import("../app-legacy/main/private-entity/company-info/company-info.module").then(
								(m) => m.CompanyInfoModule,
							),
					},
					{
						path: "payslips",
						loadComponent: () =>
							import(
								"../app-legacy/main/payroll/staff-management/employee-profile/employee-payslips/employee-payslips.component"
							).then((cmp) => cmp.EmployeePayslipsComponent),
					},
					{
						path: "expenses",
						loadChildren: () =>
							import("../app-legacy/main/private-entity/expenses/expenses.module").then((m) => m.ExpensesModule),
					},
					{
						path: "billing",
						loadChildren: () =>
							import("../app-legacy/main/private-entity/billing/billing.module").then((m) => m.BillingModule),
					},
					{
						path: "receipts",
						loadChildren: () =>
							import("../app-legacy/main/private-entity/receipts/receipts.module").then((m) => m.ReceiptsModule),
					},
					{
						path: "expenses/add",
						loadComponent: () =>
							import("../app-legacy/main/private-entity/expenses/expense-add/expense-add.component").then(
								(cmp) => cmp.ExpenseAddComponent,
							),
					},
				],
			},
			{
				path: "",
				redirectTo: "/dashboard",
				pathMatch: "full",
			},
			{
				path: "**",
				redirectTo: "/dashboard",
				pathMatch: "full",
			},
		],
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
